export const PricingTierSection: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className='m-3 flex flex-col rounded-xl border p-8'>{children}</div>
  );
};
